import React from "react";
import { AiOutlineException } from "react-icons/ai";

const EmptyBillCard=()=>{
    return <div className="p-5 mt-5 flex justify-center items-center flex-col">
             <AiOutlineException  className="text-5xl text-gray-600" />
            <p className="text-center text-sm text-gray-600 mt-2 ">هیچ قبضی یافت نشد.</p>
            </div>
}
export default EmptyBillCard;